import envStore from '@/env'

export type IDecimalConfigProps = {
  digits: number
  padWithZero: boolean
  withComma?: boolean
}

/**
 * 獲取小數點配置
 * 使用 getter 函數確保每次都能獲取最新的 decimalNumber 值
 */
export const getDecimalConfig = () => ({
  Number: { digits: envStore.decimalNumber, padWithZero: true },
  Percentage: { digits: 2, padWithZero: true },
  EmissionCoeffi: { digits: 10, padWithZero: true }, // 排放係數 小數點到第10位四捨五入
  Emission: { digits: 15, padWithZero: true }, // 所有排放量
  transWeight: { digits: 15, padWithZero: true }, // transWeight  載運重量
  carbonFootprints_originQuantity: { digits: 15, padWithZero: true }, // originQuantity
  baseQuantity: { digits: envStore.decimalNumber, padWithZero: true }, // 單位數量
  originQuantity: { digits: envStore.decimalNumber, padWithZero: true }, // 原幣金額
  CustCarbonTotalEmission: { digits: 4, padWithZero: true }, // 客戶盤查總排放量
  assessmentScore: { digits: 1, padWithZero: false }, // 評估分數
  exchangeRate: { digits: 4, padWithZero: true }, // 匯率 小數點到第4位四捨五入
})

/**
 * 為了向後兼容，保留 DECIMAL_CONFIG 作為 getter
 * 但建議使用 getDecimalConfig() 函數
 */
export const DECIMAL_CONFIG = new Proxy({} as ReturnType, {
  get(target, prop) {
    return getDecimalConfig()[prop as keyof ReturnType]
  },
})
/**
 * equipmentCount
 * 不套用
 */
/** 統計圖度數套用 envStore 的小數點 */
/** thousandsSeparator
 * commaSeparated
 * 統計管理 admin_reportMgm
 */
// export const REPORT_DECIMAL_CONFIG = {
//   Number: {
//     digits: 4,
//     padWithZero: true,
//   },
//   Percentage: {
//     digits: 2,
//     padWithZero: true,
//   },
// }
/**
 * 廢棄物重量 科符
 * expoNumber = 套的是環境的預設值
 * percentNumber = 套的是環境的預設值
 * toLimitNumber = 套的是環境的預設值
 * toEquivalentEmissionFormat= 套的是環境的預設值
 * toEmissionCoeffiFormat =排放係數 固定小數點 10
 * positiveNumber = 套的是環境的預設值
 * convertPercentage = 套的是環境的預設值
 *
 * * 統計圖表 > 減碳目標資訊
 * toEmissionFormatByDecimal 預設 2
 *
 * toNumberFormatByDecimal 預設 2 不顯示科學符號
 * toThousandSeparator = 套的是環境的預設值
 * toThousandSeparatorV0 = 沒有小數點設定
 */
